import React from 'react';
import { useSiteContent } from '../content/SiteContentProvider';
import { renderInlineMarkdown } from '../lib/inlineMarkdown';

export default function SitePromoBanner() {
  const { content } = useSiteContent();
  const banner = content.promoBanner;

  if (!banner.enabled || !banner.text) {
    return null;
  }

  return (
    <div className="w-full bg-yellow-400 text-[#0d0e15]">
      <div className="max-w-7xl mx-auto px-4 lg:px-12 py-2.5 text-center text-[11px] sm:text-xs font-bold uppercase tracking-[0.18em] leading-tight">
        {renderInlineMarkdown(banner.text, {
          linkClassName: 'underline decoration-2 underline-offset-4 hover:decoration-4 transition-all',
        })}
      </div>
    </div>
  );
}
